import type { NewsItem } from "@/types";

export const news: NewsItem[] = [
  {
    id: "n01",
    title: "《机械之心》全球首映礼落幕，主创畅谈“意识”这一核心命题",
    excerpt:
      "在首映红毯上，导演 Alan Reeve 与主演马克·雷恩分享了影片创作幕后，并回应了观众关于结局留白的讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20busy%20film%20festival%20red%20carpet%20at%20night%20with%20photographers%20flashes%20and%20elegant%20spotlights%2C%20cinematic%20editorial%20photography%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=800&height=500&seq=news-n01&orientation=landscape",
    date: "2025-06-24",
    category: "电影",
    linkTitleId: "t03",
  },
  {
    id: "n02",
    title: "《长夜未央》收官口碑登顶，权谋剧迎来新的“台词天花板”",
    excerpt:
      "该剧以大结局收束多条支线，观众普遍认为其伏笔回收与人物弧光处理堪称教科书级别，相关话题连续多日登上热搜。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20modern%20television%20drama%20press%20conference%20stage%20with%20a%20microphone%20and%20a%20glowing%20brand%20backdrop%2C%20cinematic%20editorial%20photography%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=800&height=500&seq=news-n02&orientation=landscape",
    date: "2024-12-20",
    category: "电视剧",
    linkTitleId: "t09",
  },
  {
    id: "n03",
    title: "华语科幻持续升温，多部新作进入后期制作阶段",
    excerpt:
      "从《量子回声》到《山海拾光》，类型融合正在成为新趋势，业内认为想象力的边界正在被不断拓宽。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20modern%20film%20production%20studio%20set%20with%20camera%20rigs%20and%20cinematic%20lighting%20equipment%2C%20cinematic%20editorial%20photography%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=800&height=500&seq=news-n03&orientation=landscape",
    date: "2025-05-08",
    category: "行业",
    linkSpecialId: "s03",
  },
  {
    id: "n04",
    title: "悬疑类型片回暖，观众更偏爱“慢推理”式的沉浸体验",
    excerpt:
      "数据显示，强调氛围与人性刻画的悬疑作品在长尾播放中表现更佳，观众对反转的“合理性”要求明显提高。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20dark%20moody%20desk%20with%20scattered%20case%20files%20a%20magnifying%20glass%20and%20a%20dim%20desk%20lamp%2C%20cinematic%20editorial%20photography%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=800&height=500&seq=news-n04&orientation=landscape",
    date: "2025-04-02",
    category: "行业",
    linkSpecialId: "s01",
  },
  {
    id: "n05",
    title: "冬日治愈片单走红，安静的故事也能成为“情绪出口”",
    excerpt:
      "从《海边来信》到《厨房里的哲学家》，一批慢节奏作品在社交平台被反复推荐，成为许多人的睡前陪伴。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20cozy%20winter%20window%20seat%20with%20a%20soft%20blanket%20a%20cup%20of%20hot%20cocoa%20and%20falling%20snow%20outside%2C%20cinematic%20editorial%20photography%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=800&height=500&seq=news-n05&orientation=landscape",
    date: "2024-12-01",
    category: "推荐",
    linkSpecialId: "s02",
  },
  {
    id: "n06",
    title: "综艺市场观察：从“看明星”回到“看内容”，真实感成为新卖点",
    excerpt:
      "音乐竞演与荒野生存类节目凭借扎实的制作赢得口碑，观众的注意力正从话题转向内容本身。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20colorful%20modern%20streaming%20platform%20interface%20displayed%20on%20a%20large%20monitor%20in%20a%20bright%20studio%2C%20cinematic%20editorial%20photography%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=800&height=500&seq=news-n06&orientation=landscape",
    date: "2025-03-10",
    category: "综艺",
    linkTitleId: "t17",
  },
  {
    id: "n07",
    title: "《星际拓荒者》续订第二季，主创透露将探索更遥远的星系",
    excerpt:
      "剧集以人物关系与科学思辨获得好评，制作方表示第二季会延续冷峻美学并拓展世界观。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20glowing%20cinema%20screen%20in%20a%20dark%20empty%20theater%20with%20rows%20of%20empty%20velvet%20seats%2C%20cinematic%20editorial%20photography%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=800&height=500&seq=news-n07&orientation=landscape",
    date: "2025-04-16",
    category: "电视剧",
    linkTitleId: "t13",
  },
  {
    id: "n08",
    title: "观影指南：如何快速挑选一部适合今晚心情的作品",
    excerpt:
      "我们整理了一套按“情绪”而非“类型”选片的方法，帮你从海量内容里迅速找到此刻真正想看的那一部。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20neat%20stack%20of%20screenplay%20scripts%20and%20a%20clapperboard%20on%20a%20warm%20wooden%20desk%2C%20cinematic%20editorial%20photography%2C%20dramatic%20atmospheric%20lighting%2C%20rich%20color%20grading%2C%20epic%20composition%2C%20soft%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=800&height=500&seq=news-n08&orientation=landscape",
    date: "2025-05-20",
    category: "指南",
  },
];